import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async';
import useDebouncedCallback from 'utils/customHooks/useDebouncedCallback';
//api
import { getLibrariesApi } from 'api/library';

const SearchLibraryInputForFilters = ({ value, onSelected, defaultLibrary = null, showLabel = '' }) => {
  const { t } = useTranslation(['backoffice']);
  const [librarySelected, setLibrarySelected] = useState(null);

  useEffect(() => {
    if (defaultLibrary) {
      setLibrarySelected({
        label: defaultLibrary.denominacion || defaultLibrary.nombre_fiscal || defaultLibrary.value,
        value: defaultLibrary.id || defaultLibrary.value,
      });
    } else {
      setLibrarySelected(null);
    }
  }, [defaultLibrary]);

  // Resetear cuando value se vuelve null o undefined
  useEffect(() => {
    if (!value) {
      setLibrarySelected(null);
    }
  }, [value]);

  const onSearch = async (value) => {
    if (value && value.length > 1) {
      const { status, data } = await getLibrariesApi({ 
        denominacion: value, 
        page: 1, 
        page_size: 10 
      });
      if (status === 200 && data?.results) {
        return data.results.map((item) => ({
          ...item,
          label: item.denominacion || item.nombre_fiscal || '',
          value: item.id,
        }));
      }
    }
    return [];
  };

  const loadOptions = useDebouncedCallback((value, callback) => {
    onSearch(value).then((options) => callback(options));
  }, 1000);

  return (
    <div>
      {showLabel && (
        <Form.Label className="order-control-filters__label">
          {showLabel}
        </Form.Label>
      )}
      <AsyncSelect
        cacheOptions
        defaultOptions={librarySelected ? [librarySelected] : []}
        defaultValue={librarySelected}
        defaultInputValue={librarySelected?.label}
        loadOptions={loadOptions}
        onChange={(selected) => {
          setLibrarySelected(selected);
          onSelected(selected);
        }}
        placeholder={t('searchByName') || 'Buscar biblioteca...'}
        classNamePrefix="library-filter-input"
        isClearable
        value={value !== undefined && value !== null ? value : librarySelected}
        styles={{
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#e9ecef' : 'white',
            color: state.isFocused ? '#212529' : base.color,
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '#e9ecef',
            },
          }),
        }}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: 'neutral60',
          },
        })}
      />
    </div>
  );
};

SearchLibraryInputForFilters.propTypes = {
  onSelected: PropTypes.func,
  value: PropTypes.any,
  defaultLibrary: PropTypes.object,
  showLabel: PropTypes.string,
};

export default SearchLibraryInputForFilters;
